import { Path, QueryFilter } from '@softline/core';
import { FilterItemConfig } from '../../../types/filter-config';

/**
 * One window of filter values. `values` holds only what can be rendered (null/empty column
 * values are dropped), `rawCount` is how many rows the backend actually returned - paging has
 * to follow the raw count, otherwise a window whose column is empty everywhere ends the list
 * although more pages exist.
 */
export interface PageFilterValuePage<T extends object> {
  readonly values: Partial<T>[];
  readonly rawCount: number;
}

export abstract class PageFilterDataService<T extends object> {
  abstract loadCount(items: FilterItemConfig<T>[], queryFilter: QueryFilter<T>): Promise<Record<Path<T>, number>>;
  abstract loadItems(item: FilterItemConfig<T>, filter: QueryFilter<T> | null, start: number, end: number, search: string): Promise<PageFilterValuePage<T>>
}
